import { createSelector } from 'reselect';
import { getFormValues } from 'redux-form';

const bundlePackageSelector = (state) => state.library.bundlePackage;

export const getBundlesListArray = createSelector(
  bundlePackageSelector,
  (state) => state.bundles.list
);

export const getBundleItemVariants = createSelector(
  bundlePackageSelector,
  (state) => state.bundleComponentItemVariantName.itemVariants
);

export const FILTERS_FORM_NAME = 'bundle-package-search';
export const getFiltersFormValues = getFormValues(FILTERS_FORM_NAME);

export const BUNDLE_FORM_NAME = 'bundlePackage';
export const getBundleFormValues = getFormValues(BUNDLE_FORM_NAME);
